luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;
  button.canPlaceBet = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    return !freespins.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const { slotConfig } = this.gameConfig.data;
    const goldenbetStakes =
      slotConfig.gameModes[GLOBALS.LUCKYBET_BUY].coinSizes;
    const baseStake =
      resourceManager.getController("stakeController").BaseStake /
      slotConfig.defaultNumLines;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    this.button.buttonDisabled.alpha = allow ? 1 : 0.5;
    this.luckyBetAnim.visible = allow;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      button.onConfig.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionStarted",
      button.promotionStarted.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionEnded",
      button.promotionEnded.bind(button)
    );
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton:luckyBetMessage"
    );
    button.animParent = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );

    // create here on top of button
    button.luckyBetAnim = resourceManager.createObject(
      "movie",
      "luckyBetAnim",
      button.animParent,
      {
        definition: "LuckyBet",
        x: -105,
        y: -99,
        loop: false,
        scale: 1,
      }
    );
    button.luckyBetAnim.gotoAndStop(0);
    button.luckyBetAnim.visible = true;

    button.luckyBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;

    button.hitArea = new PIXI.Rectangle(-80, -60, 180, 125);
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.luckyBetAnim.gotoAndStop(0);

      gameData.encoreEnabled = false;

      button.handleStakeChange(true);
    }
  };

  button.handleStakeChange = function (broadcast) {
    const stakeController = resourceManager.getController("stakeController");
    const baseStake = stakeController.BaseStake;
    const bpl = baseStake / 25;
    const luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);

    if (broadcast) {
      stakeController.cancelLuckyBet();
    }
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    button.luckyBetAnim.gotoAndStop(29);
    button.handleStakeChange(true);
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;
    game.resetWinnings();

    if (button._flags.showLuckyBetActive) {
      if (button.luckyBetMessage !== undefined) {
        button.luckyBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(
          2000,
          undefined,
          function () {
            button.innerFadeTimer = timerManager.addTimer(
              750,
              function (progress) {
                button.luckyBetMessage.alpha = 1 - progress;
              },
              function () {
                button.luckyBetMessage.alpha = 0.0;
              }
            );
          }
        );

        button.luckyBetAnim.gotoAndPlay(0);
        soundManager.play("activateGoldenBet");

        gameData.encoreEnabled = true;
        button.handleStakeChange(true);
      }
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play("cancelGoldenBet");
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "luckyBetToggleButton",
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
